// duplicateAdSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const duplicateAdSlice = createSlice({
  name: 'DuplicateAd',
  initialState,
  reducers: {
    setDuplicateAd: (state) => true,
    resetDuplicateAd: (state) => false,
  },
});

export const setDuplicateAdThunk = () => (dispatch) => {
  dispatch(duplicateAdSlice.actions.setDuplicateAd());
};

export const resetDuplicateAdThunk = () => (dispatch) => {
  dispatch(duplicateAdSlice.actions.resetDuplicateAd());
};

export const { setDuplicateAd, resetDuplicateAd } = duplicateAdSlice.actions;

export default duplicateAdSlice.reducer;
